export enum FundStatus {
  Closed = 'Closed',
  Active = 'Active',
  /** HAT-1301: frozen for inactivity; documents destroyed, reactivation requires new ID documents. */
  Frozen = 'Frozen',
}
